import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      setLoading(true);
      const { data } = await api.post("/api/admin/login", {
        username: form.username.trim(),
        password: form.password,
      });
      localStorage.setItem("admintoken", data.token);
      localStorage.setItem("adminuser", JSON.stringify(data.user));
      nav("/dashboard", { replace: true });
    } catch (ex) {
      setErr(ex?.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 999,
    border: "1px solid #cbd5e1",
    fontSize: 14,
    outline: "none",
  };

  const labelText = {
    fontSize: 13,
    color: "#64748b",
    marginBottom: 4,
    display: "block",
  };

  const btnPrimary = {
    width: "100%",
    padding: "11px 14px",
    borderRadius: 999,
    border: 0,
    background:
      "linear-gradient(135deg,#0f766e 0%,#22c55e 40%,#0ea5e9 100%)",
    color: "#fff",
    fontWeight: 600,
    fontSize: 15,
    cursor: "pointer",
  };

  const btnSecondary = {
    padding: "8px 18px",
    borderRadius: 999,
    border: "1px solid #e5e7eb",
    background: "#fff",
    color: "#0f172a",
    fontSize: 13,
    fontWeight: 500,
    cursor: "pointer",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background:
          "radial-gradient(circle at top, #e0f2fe 0, #f9fafb 45%, #e5e7eb 100%)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 520,
          borderRadius: 28,
          background: "#ffffff",
          boxShadow: "0 24px 60px rgba(15,23,42,0.08)",
          padding: "28px 32px 32px",
        }}
      >
        {/* Header row: title + home */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <div>
            <div
              style={{
                fontSize: 26,
                fontWeight: 800,
                color: "#0f172a",
              }}
            >
              Admin Login
            </div>
            <div
              style={{
                fontSize: 13,
                color: "#6b7280",
                marginTop: 4,
              }}
            >
              Enter your credentials to access the dashboard.
            </div>
          </div>

          <button
            type="button"
            style={btnSecondary}
            onClick={() => nav("/")}
          >
            ← Home
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onSubmit}>
          <label style={{ display: "block", marginTop: 4 }}>
            <span style={labelText}>Username</span>
            <input
              name="username"
              value={form.username}
              onChange={onChange}
              autoComplete="username"
              style={inputStyle}
              placeholder="admin"
            />
          </label>

          <label style={{ display: "block", marginTop: 18 }}>
            <span style={labelText}>Password</span>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={onChange}
              autoComplete="current-password"
              style={inputStyle}
              placeholder="••••••••"
            />
          </label>

          {err && (
            <div
              style={{
                color: "#b91c1c",
                marginTop: 12,
                fontSize: 13,
                background: "#fef2f2",
                borderRadius: 16,
                padding: "8px 10px",
                border: "1px solid #fecaca",
              }}
            >
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              ...btnPrimary,
              marginTop: 26,
              opacity: loading ? 0.85 : 1,
            }}
          >
            {loading ? "Signing in…" : "Login to Dashboard"}
          </button>

          <div
            style={{
              marginTop: 18,
              fontSize: 12,
              color: "#9ca3af",
              textAlign: "center",
            }}
          >
            Having trouble logging in? Contact your system administrator.
          </div>
        </form>
      </div>
    </div>
  );
}
